import cards from "./cards/cards";
import {
  getAuthorTemplate,
  getBlogTemplate,
  getInteriorTemplate,
  getProductCardTemplate,
} from "./utils/templates";

const showMore = ({listSelector = `.js-show-more-list`, buttonSelector = `.js-show-more-btn`}) => {
  const buttonElement = document.querySelector(buttonSelector);

  const state = {
    isLoaded: false,
    amount: 0,
    nextPage: 2,
    totalPages: 0,
  };

  const removeButton = () => {
    if (state.nextPage > state.totalPages) {
      buttonElement.parentNode.remove();
    }
  };

  const ListTypes = {
    PRODUCT: `cathegory__list`,
    AUTHOR: `authors__list`,
    BLOG: `blog__list`,
    INTERIORS: `interiors__list`,
  };

  if (buttonElement) {
    const listElement = document.querySelector(listSelector);

    switch (true) {
      case listElement.classList.contains(ListTypes.PRODUCT):
        cards(listElement, buttonElement, state, removeButton, getProductCardTemplate);
        break;
      case listElement.classList.contains(ListTypes.AUTHOR):
        cards(listElement, buttonElement, state, removeButton, getAuthorTemplate);
        break;
      case listElement.classList.contains(ListTypes.BLOG):
        cards(listElement, buttonElement, state, removeButton, getBlogTemplate);
        break;
      case listElement.classList.contains(ListTypes.INTERIORS):
        cards(listElement, buttonElement, state, removeButton, getInteriorTemplate);
        break;
    }
  }
};

export default showMore;
